export const mockedLegislationData = [
  {
    id: 11111111,
    title: 'COMENTÁRIOS À CONSTITUIÇÃO BRASILEIRA',
    subtitle: '',
    image: '/assets/images/legislacao-capa.jpg',
    img: '/assets/images/legislacao-capa.jpg',
    description: 'Obra atualizada até 17 de março de 2022.',
    cdd: '345',
    cdu: '343',
    numberOfPages: 10,
    isbn: '978-65-5518-339-9',
    year: 2022,
    serie: 'Legislação Comentada',
    author: 'Emerson Garcia',
    editionId: 1,
    editionNumber: 1,
    editionDate: '2022-01-01',
    areasInterest: 'Penal',
    yearExibition: '2022'
  }
];

export const mockedArticlesData = [
  {
    id: 35081,
    pdfName: 'NzY1Ojc2MDo1Mzo1Ng==',
    Title: 'Abreviaturas',
    type: 1,
    subType: 1,
    sumaryID: 0,
    coordinatorWork: 'True',
    author: '',
    titlePresentation: '',
    title: 'Folha de rosto'
  },
  {
    id: 35082,
    pdfName: 'NDk4OjQ5MDoxNzo1Ng==',
    Title: 'Apresentação',
    type: 1,
    subType: 2,
    sumaryID: 0,
    coordinatorWork: 'True',
    author: '',
    titlePresentation: '',
    title: 'Expediente'
  },
  {
    id: 35085,
    pdfName: 'ODc1Ojg2MjozNjo1Ng==',
    Title: 'Art. 1',
    type: 3,
    subType: 0,
    sumaryID: 0,
    coordinatorWork: 'False',
    author: '',
    titlePresentation: 'Art. 1',
    title: 'Art. 1'
  },
  {
    id: 35086,
    pdfName: 'MTk3OjE3OToyNjo1Ng==',
    Title: 'Art. 2',
    type: 3,
    subType: 0,
    sumaryID: 0,
    coordinatorWork: 'False',
    author: '',
    titlePresentation: 'Art. 2',
    title: 'Art. 2'
  },
  {
    id: 35087,
    pdfName: 'OTc5Ojk1NDozMTo1Ng==',
    Title: 'Art. 3',
    type: 3,
    subType: 0,
    sumaryID: 0,
    coordinatorWork: 'False',
    author: '',
    titlePresentation: 'Art. 3',
    title: 'Art. 3'
  },
  {
    id: 35088,
    pdfName: 'ODQwOjgwODo2MDo1Ng==',
    Title: 'Art. 4',
    type: 3,
    subType: 0,
    sumaryID: 0,
    coordinatorWork: 'False',
    author: '',
    titlePresentation: 'Art. 4',
    title: 'Art. 4'
  },
  {
    id: 35089,
    pdfName: 'Njk3OjY1OTo0MDo1Ng==',
    Title: 'Art. 5',
    type: 3,
    subType: 0,
    sumaryID: 0,
    coordinatorWork: 'False',
    author: '',
    titlePresentation: 'Art. 5',
    title: 'Art. 5'
  },
  {
    id: 35090,
    pdfName: 'NTE5OjQ3NzoxNTo1Ng==',
    Title: 'Art. 6',
    type: 3,
    subType: 0,
    sumaryID: 0,
    coordinatorWork: 'False',
    author: '',
    titlePresentation: 'Art. 6',
    title: 'Art. 6'
  },
  {
    id: 35091,
    pdfName: 'NDk4OjQ1MToyNjo1Ng==',
    Title: 'Art. 7',
    type: 3,
    subType: 0,
    sumaryID: 0,
    coordinatorWork: 'False',
    author: '',
    titlePresentation: 'Art. 7',
    title: 'Art. 7'
  },
  {
    id: 35092,
    pdfName: 'MTM0OjgxOjIxOjU2',
    Title: 'Art. 8',
    type: 3,
    subType: 0,
    sumaryID: 0,
    coordinatorWork: 'False',
    author: '',
    titlePresentation: 'Art. 8',
    title: 'Art. 8'
  },
  {
    id: 35095,
    pdfName: 'NjU3OjY1NjoyMDo1Ng==',
    Title: 'Sobre os Autores',
    type: 2,
    subType: 19,
    sumaryID: 0,
    coordinatorWork: 'True',
    author: '',
    titlePresentation: '',
    title: 'Sobre os Autores'
  }
];
